module.exports = __webpack_public_path__ + "img/icons_to.9910ff8d.svg";